<template>
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Coupon.list.User Details') }}</strong>
                </h4>

                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Coupon.list.Coupon Title') }}</label>
                    <div class="p-col-12 p-md-10">{{ mydata.coupon_title }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Coupon.list.Description') }}</label>
                    <div class="p-col-12 p-md-10">{{ mydata.coupon_description == null ? '-Empty-' : mydata.coupon_description }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Coupon.list.Registration Date & Time') }}</label>
                    <div class="p-col-12 p-md-10">{{ formatDateTime(mydata.created_date) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Coupon.list.Status') }}</label>
                    <div class="p-col-12 p-md-10">{{ mydata.status }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Coupon.list.Coupon Image') }}</label>
                    <div>
                        <Image :src="image" :alt="image" class="product-image" width="137" height="85" preview />
                        <!-- <Image :src="image" :alt="fileName1" class="product-image" width="137" height="85" preview /> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12 p-p-0">
        <div class="card">
            <div>
                <h5>{{ $t('Coupon.list.User List') }}</h5>
            </div>
            <DataTable :value="user_list" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                <!-- v-model:selection="selected" -->
                <ConfirmDialog group="dialog" />

                <template #empty> No Data found. </template>
                <template #loading> Loading data. Please wait. </template>

                <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                <Column field="slNO" :header="$t('#')" style="min-width: 12rem">
                    <template #body="{ index }">
                        <span class="p-column-title">Name</span>
                        {{ index + 1 }}
                    </template>
                </Column>
                <Column field="name" :header="$t('Coupon.list.Nickname')" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Nickname</span>
                        {{ data.nickname }}
                    </template>
                </Column>
                <Column :header="$t('Coupon.list.Id')" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Id</span>
                        {{ data.id }}
                    </template>
                </Column>
                <Column :header="$t('Coupon.list.Point')" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Point</span>
                        {{ data.points }}
                    </template>
                </Column>
                <Column :header="$t('Coupon.list.gender')" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">gender</span>
                        {{ data.gender }}
                    </template>
                </Column>
                <Column :header="$t('Coupon.list.Age Group')" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Age Group</span>
                        {{ data.age_group }}
                    </template>
                </Column>
                <Column :header="$t('Coupon.list.Marital Status')" style="min-width: 12rem">
                    <template #body="{ data }">
                        <span class="p-column-title">Marital Status</span>
                        {{ data.married == 1 ? 'married' : 'unmarried' }}
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>
    <div class="p-col-12">
        <div class="p-d-flex p-jc-between">
            <div>
                <router-link :to="'/UpdateCoupon/' + $route.params.id"
                    ><Button label="help" class="p-button-outlined p-button-help p-mr-2 p-mb-2"><i class="pi pi-user-edit p-mr-2"></i> Edit</Button></router-link
                >
                <Button @click="del($route.params.id)" label="delete" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"><i class="pi pi-trash p-mr-2"></i> delete</Button>
            </div>
            <div>
                <Button @click="$router.go(-1)" label="Go Back" class="p-button-outlined p-mr-2 p-mb-2" />
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import CouponService from '../../service/API/CouponService';
import formatDateTime from '../../mixin/mixinFunction';
// import {useRouter} from 'vue-router'
export default {
    mixins: [formatDateTime],
    data() {
        return {
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},
            user_list: [],
            image: '',
        };
    },
    created() {
        this.couponService = new CouponService();
    },
    methods: {
        del(id) {
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'patch', url: `/user/delete`, data: { id: id, status: 'deleted' } })
                        .then((res) => {
                            console.warn(res);
                            this.$router.push({ name: 'User' });
                        })
                        .catch((err) => {
                            if (err.response.data.statusCode == '401') {
                                localStorage.removeItem('token');
                                window.location.href = '/login';
                            }
                        });

                    this.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
    mounted() {
        this.couponService.assignCouponList(this.$route.params.id).then((res) => {
            console.log(res.data);
            this.user_list = res.data;
        });
        this.couponService.couponDetails(this.$route.params.id).then((data) => {
            console.log(data);
            this.mydata = data[0];
            this.image = data[0].image;
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
</style>
